<template>
  <div class="index">
    <!--轮播图-->
    <!-- <div class="index_swiper">
      <swiper :options="swiperOption">
        <swiper-slide>
          <div class="banner1 banner"></div>
        </swiper-slide>
        <swiper-slide style="cursor: pointer;" @click.native="openvideo">
          <div class="bannerc banner"></div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>-->
    <div class="index_swiper">
      <div class="showSwiper"></div>
      <swiper :options="swiperOption" class="swiper-container" ref="mySwiper">
        <swiper-slide>
          <div class="banner1 banner"></div>
        </swiper-slide>
        <swiper-slide style="cursor: pointer;" @click.native="openvideo">
          <div class="bannerc banner"></div>
        </swiper-slide>
        <!-- 注意！一定要把swiper-pagination这个分页器写在swiper标签里面，swiper-slide标签外面 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
    </div>
    <!-- player -->
    <div class="videobox" v-show="isvideo">
      <div class="video_center" @contextmenu.prevent="menuPlayer()">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player>
        <!-- <video src="../../../static/video/kanguji.mp4" class="video" ></video> -->
        <p class="closetagbox" @click="closevideo" alt></p>
      </div>
    </div>
    <div class="component_search">
      <search-box style="margin:30px auto 0;"></search-box>
    </div>

    <!--热门推荐-->
    <div class="hotcom">
      <div class="content_top">
        <img src="../../assets/public/hot_cion@2x.png" class="top_img" alt="热门推荐小图标" />
        <router-link to="recommend" tag="div" class="hot_text">
          热门推荐
        </router-link>
        <!-- <router-link to='recommend' tag='div' class="more">
        <p>查看更多</p><span class="more_img"></span></router-link>-->
      </div>
      <div class="hot_center">
        <router-link
          tag="a"
          class="hot_center_left"
          :to="{path:'/bookDetail',query:{book_id:bighot.book_id}}"
          target="_blank"
        >
          <p class="hot_text1" :title="bighot.name" v-html="hotname"></p>
          <p class="hot_author" :title="bighot.author">{{bighot.author}}</p>
          <p class="hot_com">热门推荐</p>
          <!-- <img :src="bighot.cover" class="hl_book" @mouseenter="showBig(bighot.book_id)" @mouseleave="hideBig(bighot.book_id)"/> -->
          <img :src="bighot.cover" class="hl_book" />
          <transition name="slide-fade">
            <img :src="bighot.cover" class="hl_book_scale" v-show="showId==bighot.book_id" />
          </transition>
        </router-link>
        <div class="hot_center_right">
          <!-- <li v-for="(item,index) in hotcom" v-bind:key="index" class="hr_li" v-show="index != 0" > -->
          <router-link
            tag="a"
            :to="{path:'/bookDetail',query:{book_id:item.book_id}}"
            target="_blank"
            v-for="(item,index) in hotcom"
            v-bind:key="index"
            class="hr_li"
            v-show="index != 0"
          >
            <p class="hr_tip"></p>
            <!-- <img :src="item.cover" class="hr_book" @mouseenter="showBig(item.book_id)" @mouseleave="hideBig()" /> -->
            <img :src="item.cover" class="hr_book" />
            <transition name="slide-fade">
              <img :src="item.cover" class="hr_book_scale" v-show="showId==item.book_id" />
            </transition>
            <p class="hr_title" :title="item.name">{{item.name}}</p>
            <p class="hr_author" :title="item.author">{{item.author}}</p>
          </router-link>
        </div>
      </div>
    </div>
    <!--古籍分类-->
    <div class="anbook">
      <div class="content_top">
        <img src="../../assets/public/class_icon@2x.png" class="top_img" alt="古籍分类小图标" />
        <router-link to="ancientBooks" tag="div" class="hot_text">
          古籍分类
        </router-link>
        <!-- <router-link to='ancientBooks' tag='div' class="more">
        <p>查看更多</p><span class="more_img"></span></router-link>-->
      </div>
      <div class="anbook_content">
        <div class="anb_center" id="anb_center">
          <div class="anb_firstlevel">
            <p class="anb_country" :class="{'anb_active':iscountry}" @click="country(1)">本土著述</p>
            <p class="anb_country" :class="{'anb_active': !iscountry}" @click="country(2)">域外著述</p>
          </div>
          <ul class="anb_secondlevel" v-if="iscountry">
            <li
              v-for="(item,index) in medicalclass1"
              v-bind:key="index"
              class="anb_li"
              @click="anb_content(item.category_id,index)"
              ref="anbli"
            >{{item.name}}</li>
          </ul>
          <ul class="anb_secondlevel" v-else>
            <li
              v-for="(item,index) in medicalclass2"
              v-bind:key="index"
              class="anb_li"
              @click="anb_content(item.category_id,index)"
              ref="anbli"
            >{{item.name}}</li>
          </ul>
          <div class="anb_content">
            <div class="anbc_li" v-for="(item,index) in anbcon" v-bind:key="index">
              <router-link
                tag="a"
                :to="{path:'/bookDetail',query:{book_id:item.book_id}}"
                target="_blank"
                class="anbc_li_head"
                ref="bookbg"
                :style="{backgroundColor:item.background}"
              >
                <img :src="item.cover" class="anbc_img" />
                <img src="../../assets/public/shadow_bg@2x.png" alt class="shadow" />
                <!-- <img :src="item.cover" class="anbc_img" @mouseenter="showBig2(item.book_id)" @mouseleave="hideBig2()"/> -->
                <!-- <img src="../../assets/public/shadow_bg@2x.png" alt="" class="shadow" @mouseenter="showBig2(item.book_id)" @mouseleave="hideBig2()"> -->
                <transition name="slide-fade">
                  <div class="scale_box" v-show="showId2==item.book_id">
                    <img :src="item.cover" class="anbc_img_scale" />
                    <img src="../../assets/public/shadow_bg@2x.png" alt class="shadow_scale" />
                  </div>
                </transition>
              </router-link>
              <p class="anbc_p">{{item.name}}</p>
            </div>
          </div>
        </div>
        <div class="quotation">
          <img src="../../assets/index/quotation_left@2x.png" alt="左逗号" class="left" />
          <img src="../../assets/index/quotation_right@2x.png" alt="右逗号" class="right" />
        </div>
        <div class="right_comments" id="right_comments">
          <div class="title">
            <span>最</span>
            <span>新</span>
            <span>心</span>
            <span>得</span>
          </div>
          <ul class="comments">
            <li class="comment" v-for="(item,index) in comments" :key="index">
              <div class="user">{{item.user_name}}</div>
              <div class="comment_content">
                <span class="left"></span>
                {{item.content}}
                <span class="right"></span>
              </div>
              <div class="book">
                评自
                <span @click="book(item)">《{{item.book_name}}》</span>
              </div>
              <div class="date">{{item.create_time}}</div>
            </li>
          </ul>
          <div class="footer"></div>
        </div>
      </div>
    </div>
    <div class="guoqibox" v-if="isjump">
      <div class="guoqihead">
        <div class="gqleft">
          提示
        </div>
        <div class="gqcent">

        </div>
        <div class="gqright" @click="oksb">
          <img src="../../assets/index/icon_关闭@2x.png" alt="">
        </div>
      </div>
      <div class="guoqicenter">
        <div class="gqgt">
          <img src="../../assets/index/gantan.png" alt="">
        </div>
        <div class="gqwz">
          您的产品支持服务已经到期，将影响您的使用，<br>请与服务商联系！
        </div>
        <div class="gqbtn">
          <button @click="oksb1" class="gqbutton">我知道了</button>
        </div>
      </div>
    </div>
    <!-- <div class="doctor">
      <div class="content_top">
        <img src="../../assets/public/doctor_icon@2x.png" class="top_img" alt="名医工作室小图标" />
        <router-link to="doctor" tag="div" class="hot_text">
          名医工作室
        </router-link>
      </div>
      <div class="doctor_content">
        <div
          class="doctor_li"
          v-for="(item,index) in doctorArr"
          :key="index"
          @click="doctorgo(item)"
        >
          <img :src="item.list_img" />
        </div>
      </div>
    </div>-->
  </div>
</template>
<script>
// require styles
import data from "../../../static/doctors.json";
import searchBox from "../public/searchBox.vue";
import { addstamp } from "../../util/stamp";
// import Swiper from "swiper"
// import "swiper/dist/css/swiper.css";
export default {
  data() {
    return {
      myTitle: "标题aaaaaaa",
      //swiper
      //   swiperOption: {
      // 	autoplay: {
      // 		delay:8000
      // 	},
      //     speed: 600,
      //     loop: true,
      //     autoplayStopOnLast: false,
      //     pagination: {
      //       el: ".swiper-pagination"
      //     },
      //     navigation: {
      //       nextEl: ".swiper-button-next", //前进按钮的css选择器或HTML元素。
      //       prevEl: ".swiper-button-prev", //后退按钮的css选择器或HTML元素。
      //       hideOnClick: true, //点击slide时显示/隐藏按钮
      //       disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。
      //       hiddenClass: "my-button-hidden" //按钮隐藏时的Class
      //     },
      //     pagination: {
      //       el: ".swiper-pagination",
      //       type: "bullets",
      //       progressbarOpposite: true, //使进度条分页器与Swiper的direction参数相反
      //       bulletElement: "li", //设定分页器指示器（小点）的HTML标签。
      //       dynamicBullets: false, //动态分页器，当你的slide很多时，开启后，分页器小点的数量会部分隐藏。
      //       dynamicMainBullets: 2, //动态分页器的主指示点的数量
      //       hideOnClick: false, //默认分页器会一直显示。这个选项设置为true时点击Swiper会隐藏/显示分页器。
      //       clickable: true //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
      //     }
      //   },
      //   swiperSlides: [1, 2],
      isjump:false,
      swiperOption: {
        /* 表示pagination的html标签class是swiper-pagination */
        pagination: ".swiper-pagination",
        autoplay: 5000, //可选选项，自动滑动
        loop: true, //可选选项，开启循环
        speed: 1000,
        autoplayDisableOnInteraction: false,
        keyboardControl: true, //键盘滚动
        calculateHeight: true, //自动高度
        pagination: ".pagination",
		paginationClickable: true, //点击分页器的指示点时会发生Swiper。
            nextButton: ".swiper-button-next", //前进按钮的css选择器或HTML元素。
            prevButton: ".swiper-button-prev", //后退按钮的css选择器或HTML元素。
      },

      //video
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src:
              "https://kxshop.oss-cn-shanghai.aliyuncs.com/library_video/kanguji.mp4" //url地址
            // src: "../../../static/video/kanguji.mp4" //url地址
          }
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      hotcom: [],
      iscountry: true,
      medicalclass1: [],
      medicalclass2: [],
      anbcon: [],
      bgcolor: ["#E2F9FF", "#FFE4E4", "#FFF6E4", "#F4F4F4", "#E4ECFF"],
      userid: "",
      bighot: {},
      checkbook_id1: 0,
      checkbook_id2: 0,
      hotname: "",
      comments: null,
      height: "",
      showId: null,
      showId2: null,
      isone: true,
      isvideo: false,
      doctorArr: [],
      is_bind: false,
      isbindnumber: true,
      mobile: null,
      verification_code: null,
      isuserlogin: true,
      issubmit: false,
      disabled: false,
      time: 0,
      btntxt: "获取验证码",
      is_chiose_user: false,
      chiose_userArr: []
    };
  },
  metaInfo: {
    title: "千年医典数据库-科学支撑中医临床、教学科研、健康养生",
    meta: [
      {
        name: "keywords",
        content: "中外经典医学古籍,本土,域外,古籍分类,素问,黄帝内经"
      },
      {
        name: "description",
        content: "五千年中医智慧集成，实现中外经典医学古籍在线智能阅读功能"
      }
    ]
  },
  components: {
    searchBox
    // swiper,
    // swiperSlide
  },
  computed: {
    player() {
      return this.$refs.myPlayer.player;
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.userid = parseInt(this.$store.state.user_id);
    this.loadhot();
    this.country(1);
    this.getComments();
    this.getstudios();
    this.isjump = this.$store.state.isjump;
    const hashLocation = this.$route.path;
    //   const newLocation = hashLocation.split("#/")[1];
    const url = "https://www.kanguji.com" + hashLocation;
    this.$matomo.setCustomUrl(url); //覆盖页面报告的url，可以自定义页面url，加上本页面路由
    //   this.$matomo.trackEvent(shopCode,hashLocation);//事件
    // this.$matomo.trackPageView(hashLocation);//页面名称,可以自定义页面名称
    // this.doctorArr = data
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
    // console.log(this.$store.state.loginstatus)
  },
  methods: {
    oksb(){
      this.isjump = false
    },
    oksb1(){
      this.$router.push({ path: "/login" });
    },
    //古籍分类部分内容
    anb_content(id, index) {
      var that = this;
      var params = {
        page: 1,
        page_size: 9,
        category_id: id,
        user_id: this.userid,
        level: 2
      };
      this.$axios
        .get("/books", {
          params
        })
        .then(function(res) {
          // console.log(res.data.data.books)
          that.anbcon = res.data.data.books;
          var rand = "";
          for (var i = 0; i < that.anbcon.length; i++) {
            var a = parseInt(5 * Math.random());
            if (rand != a) {
              that.anbcon[i]["background"] = that.bgcolor[a];
            } else {
              i = i - 1;
              continue;
            }
            rand = a;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
      if (typeof this.$refs.anbli != "undefined") {
        for (var i = 0; i < this.$refs.anbli.length; i++) {
          this.$refs.anbli[i].style.color = "#333";
        }
        this.$refs.anbli[index].style.color = "#E6522B";
      }
      if (this.iscountry) {
        this.checkbook_id1 = index;
      } else {
        this.checkbook_id2 = index;
      }
    },
    //加载热门部分
    loadhot() {
      var that = this;
      var params = {
        page: 1,
        page_size: 7,
        user_id: this.userid
      };
      // var sign = addstamp(params)
      // delete params.token
      // params['sign'] = sign
      // console.log(params)
      this.$axios
        .get("/book/hot", {
          params
        })
        .then(function(res) {
          // console.log(res)
          that.hotcom = res.data.data.books;
          that.bighot = res.data.data.books[0];
          var name = that.bighot.name.split("");
          that.hotname = name.join(
            '<span style="font-size:18px;color:#aaa;">/</span>'
          );
          //					$(".hot_text1 span")
          //style="font-size:18px;color:#aaa;"
          //					console.log($(".hot_text1").children("span"))
        })
        .catch(function (err) {
          console.log(err);
        })
    },
    //切换本土/域外
    country(num) {
      var that = this;
      if (num == 1) {
        this.iscountry = true;
      } else {
        this.iscountry = false;
      }
      var params = {
        type: 1,
        parent_category_id: num,
        level: 1
      };

      this.$axios
        .get("/book/categories", {
          params
        })
        .then(function(res) {
          if (num == 1) {
            that.medicalclass1 = res.data.data;
            that.anb_content(
              that.medicalclass1[that.checkbook_id1].category_id,
              that.checkbook_id1
            );
          } else {
            that.medicalclass2 = res.data.data;
            that.anb_content(
              that.medicalclass2[that.checkbook_id2].category_id,
              that.checkbook_id2
            );
          }
        })
        .catch(function (err) {
          console.log(err);
        })
    },
    //图书跳转
    book(item) {
      // this.$router.push({
      // 	path: '/bookDetail',
      // 	query: {
      // 		book_id: item.book_id
      // 	}
      // })
      let pictureUrl = this.$router.resolve({
        path: "/bookDetail",
        query: {
          book_id: item.book_id
        }
      });
      window.open(pictureUrl.href, "_blank");
    },
    // 企业详情
    toNewsDetail(id) {
      //				console.log(id)
      this.$router.push({
        path: "/companyNewsDetail",
        query: { company_id: id }
      });
    },
    onClickOutside() {
      conosle.log("898888");
    },
    getComments() {
      let that = this;
      that.isLoading = true;
      let datas = {
        size: 20
      };
      that.$axios
        .get("comments", {
          params: datas
        })
        .then(res => {
          // console.log(res.data.data)
          if (res.data.status_code == 200) {
            this.comments = res.data.data;
          } else {
            return false;
          }
        })
        .catch(function(err) {
          console.log(err);
        })
    },
    showBig(id) {
      // console.log(id)
      this.showId = id;
      // console.log(this.showId)
    },
    hideBig() {
      this.showId = null;
    },
    showBig2(id) {
      // console.log(id)
      this.showId2 = id;
      // console.log(this.showId)
    },
    hideBig2() {
      this.showId2 = null;
    },
    openvideo() {
      this.isvideo = !this.isvideo;
      this.$refs.videoPlayer.player.play();
    },
    closevideo() {
      this.$refs.videoPlayer.player.pause();
      this.isvideo = !this.isvideo;
    },
    doctorgo(item) {
      // console.log(item)
      // console.log(index)
      this.$router.push({
        path: "/doctorDetail",
        query: {
          name: item.username,
          sid: item.studio_id
        }
      });
    },
    getstudios() {
      let that = this;
      this.$axios.get("studios").then(function(res) {
        // console.log(res)
        that.doctorArr = res.data.data.slice(0, 6);
      })
        .catch(function (err) {
          console.log(err);
        })
    }, //验证手机号码部分
    sendcode() {
      var reg = 11 && /^1\d{10}$/;
      //				var url = "/sms/code?mobile=" + this.mobile;
      if (this.mobile == "") {
        alert("请输入手机号码");
      } else if (!reg.test(this.mobile)) {
        alert("手机号格式不正确");
      } else {
        this.time = 60;
        this.disabled = true;
        this.timer();
        let params = {
          phone: this.mobile
        };
        this.$axios.post("/send_code", params).then(res => {
          // console.log(res);
          // alert(res.data.status_code)
          // that.phonedata = res.data;
          if (res.data.status_code === 4001) {
            alert(res.data.msg);
          }
        })
        .catch(function (err) {
          console.log(err);
        })
      }
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "秒";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    submit() {
      var that = this;
      if (this.user == "" || this.pwd == "") {
        alert("手机号或验证码不能为空！");
      } else {
        var time = new Date();
        var params = {
          phone: this.mobile,
          verification_code: this.verification_code,
          unionid: this.$store.state.unionid,
          type: 3
        };
        this.$axios.post("/register", params).then(function(res) {
          //   console.log(res);
          if (res.data.status_code == 3001) {
            alert(res.data.msg);
          } else if (res.data.status_code == 200) {
            if (typeof res.data.data.unionid != "undefined") {
              that.$store.commit("setunionid", res.data.data.unionid);
            }
            that.is_bind = false;
            // console.log(res.data);
            that.$store.commit("setloginstatus", 200);
            that.$store.commit("setuserid", res.data.data.user_id);
            that.$store.commit("setusername", res.data.data.name);
            that.$store.commit("setheadimg", res.data.data.head_img);
            that.$store.commit("settimestamp", time.getTime());
            that.$store.commit("settoken", res.data.data.access_token);
            that.$store.commit("setphone", that.mobile);
            that.$store.commit("setis_self", true);
            that.$store.commit("setisshowbind", 0);
            that.$store.commit("setneedbind", 1);
            that.$store.commit("settwousers", 0);
            // that.$store.commit("setwelcome", 'true');
            // console.log(that.$store.state.iswelcome);
            // that.$router.push({
            //   path: that.$store.state.roued
            // });
            that.$router.go(0);
            setTimeout(function() {
              // that.$router.go(0);
              window.location.href = window.location.href.split("?")[0];
            }, 50);
          }
        })
        .catch(function (err) {
          console.log(err);
        })
      }
    }
  },
  watch: {
    isvideo() {
      if (this.isvideo) {
        $("body").css({
          overflow: "hidden"
        });
      } else {
        $("body").css({
          overflow: "auto"
        });
      }
    }
  }
};
$(function() {
  setTimeout(function() {
    //获得当前<ul>
    var $uList = $(".right_comments .comments");
    // console.log($uList)
    var timer = null;
    //触摸清空定时器
    $uList
      .hover(
        function() {
          // clearInterval(timer);
        },
        function() {
          //离开启动定时器
          timer = setInterval(function() {
            scrollList($uList);
          }, 2000);
        }
      )
      .trigger("mouseleave"); //自动触发触摸事件
    //滚动动画
    function scrollList(obj) {
      //获得当前<li>的高度
      console.log();
      var scrollHeight = $(".comment:last").outerHeight();
      $uList.stop().animate(
        {
          marginTop: scrollHeight
        },
        1000,
        function() {
          //动画结束后，将当前<ul>marginTop置为初始值0状态，再将第一个<li>拼接到末尾。
          // console.log(222222)
          $uList
            .css({
              marginTop: 0
            })
            .find(".comment:last")
            .prependTo($uList);
        }
      );
    }
  }, 5000);
});
</script>

<style scoped lang="scss" type="text/css">
.index {
  background: url(../../assets/public/bg1.png);
  font-family: PingFangSC-Light;
  position: relative;
  padding-bottom: 1px;
}
.index_swiper {
  position: relative;
  width: 100%;
  height: 460px;
}
.titlename {
  color: #409eff;
}

.swiper-slide {
  height: 460px;
}

.banner {
  width: 100%;
  height: 460px;
}
.banner1 {
  background: url(../../assets/public/banner.jpg) no-repeat center center;
  background-size: cover;
}
.bannerc {
  background: url(../../assets/index/banner2.png) no-repeat center center;
  background-size: cover;
  cursor: pointer;
  position: absolute;
  z-index: -1;
}
.video {
  width: 60%;
  display: block;
  margin: 0 auto;
}

.videobox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.72);
  .video_center {
    width: 60%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .closetagbox {
    cursor: pointer;
    // border: 1px solid red;
    width: 30px;
    height: 30px;
    position: absolute;
    top: -15px;
    right: -15px;
    background: url(../../assets/picture/bounced_esc_nor@2x.png) no-repeat
      center center;
    background-size: 100% 100%;
    &:hover {
      background: url(../../assets/picture/bounced_esc_pre@2x.png) no-repeat
        center center;
      background-size: 100% 100%;
    }
  }
}

.component_search {
  width: 930px;
  margin: 0 auto -30px;
}
.hotcom {
  width: 1200px;
  margin: 0 auto;
}

.content_top {
  width: 1200px;
  height: 45px;
  margin: 0 auto;
  margin-top: 80px;
  margin-bottom: 20px;
  line-height: 45px;
  position: relative;
  .top_img {
    width: 45px;
    height: 45px;
    display: inline-block;
    vertical-align: top;
  }
  .hot_text {
    display: inline-block;
    height: 45px;
    cursor: pointer;
    margin-left: 8px;
    color: #333;
    font-size: 24px;
    font-weight: 800;
    &:hover {
      color: #e6522b;
    }
  }
  .more {
    height: 45px;
    position: absolute;
    right: 7px;
    display: flex;
    cursor: pointer;
    color: #333;
    p {
      line-height: 45px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
    }
    .more_img {
      width: 14px;
      height: 14px;
      margin-top: 15px;
      display: inline-block;
      background-image: url(../../assets/public/right_icon@2x.png);
      background-size: cover;
      margin-left: 5px;
    }
    &:hover {
      color: #e6522b;
      .more_img {
        background-image: url(../../assets/public/right_icon_pre@2x.png);
        background-size: cover;
      }
    }
  }
}

.hot_center {
  height: 410px;
  // display: flex;
  color: #333;
  // border: 1px solid red;
  .hot_center_left {
    width: 310px;
    height: 410px;
    display: inline-block;
    background: #fff;
    position: relative;
    cursor: pointer;
    vertical-align: top;
    .hot_text1 {
      width: 215px;
      /*border: 1px solid red;*/
      height: 25px;
      margin-top: 44px;
      margin-left: 58px;
      line-height: 26px;
      font-size: 22px;
      font-weight: 500;
      // font-family: FZGB10;
      font-family: PingFangSC-Medium;
      /*white-space: nowrap;*/
      overflow: hidden;
      /*text-overflow: ellipsis;*/
    }
    .hot_author {
      width: 170px;
      height: 20px;
      margin-left: 58px;
      font-size: 16px;
      margin-top: 8px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      /*white-space: nowrap;*/
      overflow: hidden;
      /*text-overflow: ellipsis;*/
    }
    .hot_com {
      width: 29px;
      height: 94px;
      background: url(../../assets/public/hot_bg@2x.png) no-repeat center center;
      text-align: center;
      color: #fff;
      padding-top: 5px;
      box-sizing: border-box;
      position: absolute;
      top: 114px;
      left: 232px;
      z-index: 99;
    }
    .hl_book {
      width: 190px;
      height: 244px;
      position: absolute;
      top: 108px;
      left: 61px;
    }
    .hl_book_scale {
      width: 300px;
      position: absolute;
      right: -250px;
      top: 110px;
      z-index: 100;
    }
  }
  .hot_center_right {
    cursor: pointer;
    display: inline-block;
    width: 870px;
    height: 410px;
    margin-left: 14px;
    background: #fff;
    flex-wrap: wrap;
    // display: flex;
    .hr_li {
      width: 33.257%;
      height: 205px;
      display: inline-block;
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;
      background: url(../../assets/public/gray_bg@2x.png) no-repeat center
        center;
      background-size: 52%;
      position: relative;
      .hr_tip {
        width: 0px;
        height: 0px;
        border-style: solid;
        border-width: 8px 8px 8px 8px;
        border-color: #ff9a2d #ff9a2d transparent transparent;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 99;
      }
      &:hover .hr_tip {
        border-color: #e6522b #e6522b transparent transparent;
      }
      .hr_book {
        width: 106px;
        height: 136px;
        position: absolute;
        top: 41px;
        left: 68px;
      }
      .hr_book_scale {
        width: 300px;
        position: absolute;
        top: 40px;
        right: -190px;
        z-index: 100;
      }
      .hr_title {
        width: 18px;
        height: 133px;
        line-height: 1.1;
        /*border: 1px solid red;*/
        position: absolute;
        top: 42px;
        right: 66px;
        font-size: 18px;
        // font-family: FZGB10;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        overflow: hidden;
        /*display: -webkit-box;*/
        /*-webkit-line-clamp: 7;
					-webkit-box-orient: vertical;*/
      }
      .hr_author {
        width: 13px;
        height: 120px;
        line-height: 1.1;
        /*border: 1px solid red;*/
        position: absolute;
        top: 43px;
        right: 92px;
        font-size: 14px;
        overflow: hidden;
        /*display: -webkit-box;
					-webkit-line-clamp: 8;
					-webkit-box-orient: vertical;*/
        font-family: PingFangSC-Regular;
        font-weight: 400;
      }
    }
    .hr_li:nth-child(4),
    .hr_li:nth-child(7) {
      border-right: 0px;
    }
    .hr_li:nth-child(5),
    .hr_li:nth-child(6),
    .hr_li:nth-child(7) {
      border-bottom: 0px;
    }
  }
}
.anbook {
  .anbook_content {
    // display: flex;
    position: relative;
    .anb_center {
      width: 830px;
      // border: 1px solid ;
      display: inline-block;
      vertical-align: top;
      .anb_firstlevel {
        margin-top: 10px;
        margin-left: 30px;
        // display: flex;
        cursor: pointer;
        p{
          display: inline-block;
        }
        .anb_country {
          // font-family: FZGB10;
          font-family: PingFangSC-Medium, sans-serif;
          font-weight: 500;
          width: 120px;
          height: 40px;
          background-color: #fff;
          box-shadow: 0px 1px 7px 0px rgba(18, 18, 18, 0.11);
          line-height: 40px;
          text-align: center;
          font-size: 18px;
          margin-right: 20px;
          border-radius: 5px 5px 0 0;
          position: relative;
          &::after {
            content: "";
            position: absolute;
            top: 4px;
            right: -18px;
            width: 0;
            height: 0;
            border-left: 18px solid #fff;
            border-top: 36px solid transparent;
            box-shadow: 0px 10px 7px -10px rgba(18, 18, 18, 0.11);
          }
        }
        .anb_active {
          color: #fff;
          background: #e6522b;
          border-color: #e6522b;
          &::after {
            border-left: 18px solid #e6522b;
          }
        }
      }
      .anb_secondlevel {
        width: 830px;
        padding: 30px 0 0 30px;
        box-sizing: border-box;
        background-color: #fff;
        z-index: 1;
        position: absolute;
        line-height: 25px;
        display: inline-block;
        .anb_li {
          float: left;
          cursor: pointer;
          margin-right: 20px;
          color: #666;
          font-family: PingFangSC-Regular, sans-serif;
          font-weight: 400;
          font-size: 15px;
        }
        .anb_li:first-child {
          color: #e6522b;
        }
      }
      .anb_content {
        width: 830px;
        box-sizing: border-box;
        padding: 35px 0 0 35px ;
        background-color: #fff;
        margin-top: 50px;
        // display: flex;
        // display: -webkit-flex;
        // display: -moz-box;
        // display: -ms-flexbox;
        // flex-wrap: wrap;
        // justify-content: space-between;
        // align-content: flex-start;
        // align-items: flex-start;
        &::after {
          content: "";
          width: 230px;
        }
        .anbc_li {
          display: inline-block;
          width: 230px;
          cursor: pointer;
          margin-bottom: 28px;
          margin-right: 35px;
          .anbc_li_head {
            width: 100%;
            height: 173px;
            position: relative;
            &:hover {
              box-shadow: 0px 1px 11px 1px rgba(0, 0, 0, 0.07);
            }
            .anbc_img {
              width: 96px;
              height: 120px;
              margin-top: 28px;
              margin-left: 64px;
            }
            .shadow {
              width: 130px;
              height: 148px;
              position: absolute;
              bottom: 10px;
              left: 52px;
            }
            .scale_box {
              // border:1px solid;
              position: absolute;
              right: -240px;
              top: 30px;
              z-index: 100;
              .anbc_img_scale {
                width: 300px;
              }
              .shadow_scale {
                width: 390px;
                position: absolute;
                bottom: -24px;
                left: -20px;
              }
            }
          }
          .anbc_p {
            width: fit-content;
            margin: 0 auto;
            color: #333;
            text-align: center;
            margin-top: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular, sans-serif;
            font-weight: 400;
          }
        }
      }
    }
    .quotation {
      position: absolute;
      right: 0;
      top: 0;
      width: 332px;
      height: 60px;
      .left,
      .right {
        width: 60px;
        position: absolute;
        z-index: 2;
      }
      .left {
        left: 4px;
        top: 0px;
      }
      .right {
        right: 4px;
        bottom: 0px;
      }
    }
    .right_comments {
      width: 332px;
      height: 830px;
      margin-left: 30px;
      display: inline-block;
      background-color: #fff;
      overflow: hidden;
      position: relative;
      // border:1px solid;
      .title {
        height: 60px;
        width: 332px;
        background-color: #cddcff;
        text-align: center;
        line-height: 50px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, sans-serif;
        font-weight: 600;
        margin-bottom: 20px;
        position: absolute;
        z-index: 1;
        span {
          position: relative;
          &::after {
            content: "";
            display: block;
            width: 14px;
            height: 4px;
            background-color: #e6522b;
            position: absolute;
            bottom: -6px;
            left: 3px;
          }
        }
      }
      .comments {
        position: absolute;
        top: 70px;
        left: 0;
        width: 330px;
        height: 730px;
        // border:1px solid;
        overflow: hidden;
        .comment {
          background: rgba(124, 179, 245, 0.04);
          margin: 0 20px;
          padding: 30px 20px;
          box-sizing: content-box;
          border-radius: 10px;
          // border:1px solid;
          margin-bottom: 10px;
          .user {
            font-family: PingFangSC-Medium, sans-serif;
            font-weight: 500;
            color: #333;
            margin-bottom: 14px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .comment_content {
            font-family: PingFangSC-Regular, sans-serif;
            font-weight: 300;
            color: #666;
            line-height: 30px;
            font-size: 16px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 10;
            overflow: hidden;
            border-radius: 10px;
            .left,
            .right {
              display: inline-block;
              content: "";
              width: 8px;
              height: 8px;
            }
            .left {
              border-left: 2px solid rgba(33, 94, 167, 0.16);
              border-top: 2px solid rgba(33, 94, 167, 0.16);
              vertical-align: top;
              margin-top: 4px;
            }
            .right {
              border-right: 2px solid rgba(33, 94, 167, 0.16);
              border-bottom: 2px solid rgba(33, 94, 167, 0.16);
              vertical-align: middle;
              margin-top: 8px;
            }
          }
          .book {
            border-top: 1px dotted rgba(191, 191, 191, 0.8);
            margin-top: 14px;
            padding-top: 12px;
            font-family: PingFangSC-Regular, sans-serif;
            font-weight: 300;
            font-size: 14px;
            color: #999;
            span {
              font-family: PingFangSC-Regular, sans-serif;
              font-weight: 300;
              color: #e6522b;
              cursor: pointer;
            }
          }
          .date {
            font-family: PingFangSC-Regular, sans-serif;
            font-weight: 300;
            font-size: 13px;
            color: #999;
            margin-top: 4px;
          }
        }
      }
      // .footer{
      // 	content:'';
      // 	width:100%;
      // 	height:16px;
      // 	background:#E5EDFF;
      // 	position:absolute;
      // 	bottom:0;
      // 	z-index:3;
      // }
    }
  }
}
.guoqibox{
  width: 498px;
  height: 266px;
  background: #FFFFFF;
  box-shadow: 0px 1px 70px 0px rgba(0,0,0,0.15);
  border-radius: 13px;
  position: fixed;
  margin: auto;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 888;
  display: flex;
  flex-direction: column;
}
.guoqihead{
  width: 100%;
  height: 40px;
  background: #F0F0F0;
  display: flex;
  border-radius:13px  13px  0px  0px ;

}
.gqleft{
  width: 68px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.gqcent{
  flex: 1;
}
.gqright{
  width: 68px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: 24px;
    height: 24px;
  }
}
.guoqicenter{
  flex: 1;
  border-radius: 0 0 13px 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.gqgt{
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 18px;
  margin-bottom: 23px;
  img{
    width: 45px;
    height: 45px;
  }
}
.gqwz{
  width: 100%;
  height: 59px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
}
.gqbtn{

  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gqbutton{
  width: 220px;
  height: 39px;
  background: #f0f0f0;
  font-size:16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  border-radius: 15px;
  border: none;
}
.doctor,
.anbook {
  width: 1200px;
  margin: 0 auto;
  margin-top: 2px;
  margin-bottom: 80px;
}
.doctor {
  .doctor_content {
    width: 100%;
    height: 720px;
    // border: 1px solid red;
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    padding-top: 60px;
    box-sizing: border-box;
    .doctor_li {
      width: 314px;
      height: 280px;
      margin-left: 70px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
      &:nth-child(1),
      &:nth-child(4) {
        margin-left: 60px;
      }
      &:hover {
        box-shadow: 0px 1px 8px 0px rgba(130, 49, 19, 0.29);
      }
      // &:nth-child(2),
      // &:nth-child(5){
      // 	margin-left: 70px;

      // }
      // &:nth-child(3),
      // &:nth-child(6){
      // 	margin-left: 70px;

      // }
    }
  }
}
.bindmobile {
  width: 452px;
  height: 326px;
  border-radius: 8px;
  color: #333;
  box-sizing: border-box;
  padding-left: 60px;
  border: 1px solid transparent;
  position: fixed;
  top: calc(50% - 163px);
  left: calc(50% - 226px);
  background: #fff;
  z-index: 9999;
  box-shadow: 0 0 0 999px rgba(0, 0, 0, 0.42);
  .bind_title {
    font-family: AlibabaPuHuiTiB;
    margin-top: 30px;
    font-weight: bold;
    margin-bottom: 40px;
    font-size: 20px;
  }
  .change_user {
    display: flex;
    flex-wrap: wrap;
    span {
      display: block;
      margin-right: 12px;
      line-height: 44px;
    }
  }
  .login_user,
  .login_mobile {
    display: block;
    width: 260px;
    height: 44px;
    background: #eeeeee;
    border-radius: 22px;
    // margin: 0 auto;
    border: none;
    outline: none;
    text-indent: 28px;
    margin-bottom: 11px;
    font-size: 14px;
    margin-right: 40px;
  }
  .login_mobile {
    text-indent: 0px;
    overflow: hidden;
    display: flex;
    .inputtest {
      width: 66%;
      height: 44px;
      border: none;
      text-indent: 28px;
      background: #eeeeee;
      outline: none;
      font-size: 14px;
      -webkit-appearance: none;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type="number"] {
      -moz-appearance: textfield;
    }
    .timebtns {
      width: 34%;
      background: #eeeeee;
      padding: 0;
      color: #ea5832;
      border: none;
      cursor: pointer;
      box-sizing: border-box;
      outline: none;
    }
  }
  .login_btn {
    width: 260px;
    height: 44px;
    line-height: 44px;
    border-radius: 22px;
    text-align: center;
    color: #fff;
    margin-top: 34px;
    margin-left: 61px;
    cursor: pointer;
    background: #e4461e;
  }
}
.chiosebox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.42);
}
.chiose_user {
  width: 400px;
  height: 140px;
  background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 38px 0px;
  position: absolute;
  top: calc(50% - 70px);
  left: calc(50% - 200px);
  // box-shadow: 0 0 0 999px rgba(0, 0, 0, 0.42);
}
</style>



// WEBPACK FOOTER //
// src/components/page/index.vue